import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class LoggerService {
    private get canLog(): boolean {
        return !environment.production;
    }

    debug(message?: any, ...optionalParams: any[]): void {
        if (!this.canLog) return;
        console.debug(message, ...optionalParams);
    }

    info(message?: any, ...optionalParams: any[]): void {
        if (!this.canLog) return;
        console.info(message, ...optionalParams);
    }

    warn(message?: any, ...optionalParams: any[]): void {
        if (!this.canLog) return;
        console.warn(message, ...optionalParams);
    }

    error(message?: any, ...optionalParams: any[]): void {
        if (!this.canLog) return;
        console.error(message, ...optionalParams);
    }
}

